<template>
  <div class="wrapper">
    <div class="section-space">
      <div>
        <page-header heading="Featured Programs Offered" desc="Click on the tabs below to select your respective program."></page-header>
      </div>
      <section class="popular-exams-section online-course-details exams-grid" id="popularExamsSection">
        <div class="container">
          <!-- :class="{ 'sticky-tab': isHeaderSticky } -->
          <div id="header" class="featured-program-categories" v-if="categoriesFromJson.length">
            <div ref="header" :class="{ 'sticky-tab': isHeaderSticky }" class="featured-program-wrap">
              <div class="featured-program-categories-inside">
                <div
                  v-for="(category, index) in featuredProgramFilter"
                  :key="index"
                  @click="goto(category)"
                  class="exam-tabs-head upperHeadings"
                  :class="{
                    featuredProgramMainHead: selectedCategory == category.programCategoryId,
                  }"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>
            <div v-if="getCategoryGroups && getCategoryGroups.length > 0">
              <popularExams :selectedCategoryId="selectedCategory" :groups="getCategoryGroups" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { programCategories as programCategoriesStoreKeys } from "../store/keys";
import SsrCarousel from "vue-ssr-carousel";
import popularExams from "../views/course/exam/popularExams";
import pageHeader from "./pageHeader";
import axios from "axios";

export default {
  components: {
    SsrCarousel,
    popularExams,
    pageHeader,
  },
  data() {
    return {
      selectedCategory: null,
      isHeaderSticky: false,
    };
  },
  mounted() {
    this.getJsonCategories();
    this.getProgramCategories();
    window.addEventListener("scroll", () => {
      this.scrollY = Math.round(window.scrollY);
      if (this.$refs.header) {
        this.headerTop = document.getElementById("popularExamsSection").offsetTop;
        if (this.scrollY > this.headerTop + 100) {
          this.isHeaderSticky = true;
          document.body.classList.add("exam-body");
        } else {
          this.isHeaderSticky = false;
          document.body.classList.remove("exam-body");
        }
      }
    });
  },
  computed: {
    ...mapGetters(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.getters),
    getCategoryGroups() {
      const filteredCategories = this.programCategories.filter((category) => {
        return category.ProgramCategory.ProgramCategoryId == this.selectedCategory && category.HasFeaturedSoS;
      });
      const uniqueGroups = [
        ...new Set(
          filteredCategories
            .filter((obj) => {
              if (obj.Group) {
                return obj;
              }
            })
            .map((obj) => obj.Group.CourseGroupId)
        ),
      ]
        .map((id) => {
          return filteredCategories.find((obj) => obj.Group && obj.Group.CourseGroupId === id);
        })
        .map((category) => {
          return category.Group;
        });
      let filter = [{ CourseGroupDisplayName: "All", CourseGroupId: undefined }];
      if (uniqueGroups.length) {
        return uniqueGroups.length === 1 ? uniqueGroups : [...filter, ...uniqueGroups];
      } else return [];
    },
  },
  methods: {
    ...mapActions(programCategoriesStoreKeys.namespace, programCategoriesStoreKeys.actions),
    getProgramCategories() {
      this.get_ProgramCategories({
        config: {
          loader: {
            show: true,
            id: "boardLoader",
          },
        },
      }).then(() => {
        let category = this.categoriesFromJson.find((cat) => {
          return cat.HasFeaturedSoS == true && cat.isLinkAble === true;
        });
        if (category) {
          this.selectedCategory = category.programCategoryId;
        }
      });
    },
    goto(category) {
      this.selectedCategory = category.programCategoryId;
    },
    async getJsonCategories() {
      if (this.categoriesFromJson.length > 0) return;
      const baseUrl = process.env.VUE_APP_URL;
      try {
        this.showLoader = true;
        const response = await axios.get(`${baseUrl}/assets/categories/index.json`);
        this.categoriesData = response.data;
        this.get_categoriesFromJson({
          data: {
            categories: response.data,
          },
        });
        this.showLoader = false;
      } catch (error) {
        this.showLoader = false;
      }
    },
  },
};
</script>

<style></style>
